/***************************************************************
5/30/2017
Alexander Self
Timesheet Gang Form
- Timesheet form for gangs; allows a user to add multiple
  employees and allocate individual trees, bags to each employee
***************************************************************/
import React, { Component } from 'react';
import moment from 'moment';
import { TextInput, Select, NumberInput, SelectField,
  SelectBlock, SelectCostCenter, SelectSubAccount, TimePicker2, 
  DatePicker2 } from '../../inputs';
import { LOCATIONS, SHIFTS } from '../../../constants';
import { packageForm, extractUsersFromForm, setCCSubInWorkPerformed,
  getSelectedValue, generateGUID } from '../../../utils';
import GangWorkTable from './gang_work_table';
import TimesheetGangModal from './timesheet_gang_modal';
const $ = window.$;
const Materialize = window.Materialize;


class GangTimesheetForm extends Component {
  constructor(props) {
    super(props);
    this.prepareGangForm = this.prepareGangForm.bind(this);
    this.packageWorkPerformed = this.packageWorkPerformed.bind(this);
  }
  prepareGangForm() {
    let location = document.getElementById('gangLocation').value;
    let date = document.getElementById('gangWorkDate').value;
    let round = document.getElementById('round').value;
    return this.props.prepareGangTS(
      extractUsersFromForm(packageForm('gang-ts-form'), this.props.gangWorkPerformed), 
      this.props.submitter, 
      location, 
      date,
      round
    );
  }
  packageWorkPerformed(callback) {
    if (getSelectedValue('gangCostCenterCode') === '') {
      Materialize.toast('Please input a cost center', 4000, 'rounded red');
      return;
    } else if (getSelectedValue('gangSubAccount') === '') {
      Materialize.toast('Please input a subaccount', 4000, 'rounded red');
      return;
    } else if (getSelectedValue('gangField') === '' && !getSelectedValue('gangCostCenterCode').match(/06|07|08/)) {
      Materialize.toast('Please input a field', 4000, 'rounded red');
      return;
    } else if (document.getElementById('gangWorkPerformed').value === '') {
      Materialize.toast('Please input work performed', 4000, 'rounded red');
      return;
    } else if (document.getElementById('gangHours').value === '') {
      Materialize.toast('Please input hours', 4000, 'rounded red');
      return;
    }

    callback({
      workId: generateGUID(),
      costCenterCode: getSelectedValue('gangCostCenterCode'),
      subAccount: getSelectedValue('gangSubAccount'),
      workPerformed: $.trim(document.getElementById('gangWorkPerformed').value),
      hours: document.getElementById('gangHours').value,
      trainer: 0,
      differential: '',
      detail: '',
      tempGrade: '',
      equipmentNo: '',
      equipmentTrailerNo: '',
      field: getSelectedValue('gangField'),
      block: '',
      paycode: ''
    });
    document.getElementById('gangCostCenterCode').value = '';
    document.getElementById('gangSubAccount').value = '';
    document.getElementById('gangField').value = '';
    document.getElementById('gangWorkPerformed').value = '';
    document.getElementById('gangHours').value = '';
    return;
  }
  render() {
    // If this is the day after the pay period ends, give one day to allow supervisors to enter in remaining timesheets
    let startDate;
    let lastDay = moment().format('YYYY-MM-DD');
    if (lastDay === this.props.payPeriodStartDate && moment().hour() < 10) startDate = this.props.prevPPStartDate;
    else startDate = this.props.payPeriodStartDate;
    return (
      <div>
        <form onSubmit={(e) => e.preventDefault()} id="gang-ts-form">
          <div className="row">
            <div className="col s12 m12 l4">
              <DatePicker2 id={'gangWorkDate'} label={'Date'} min={startDate} max={this.props.payPeriodEndDate} />
            </div>
            <div className="col s12 m6 l4">
              <Select id={'gangLocation'} opts={LOCATIONS} label={'Location'} onChange={(e) => { this.props.fetchFieldsByLoc(e.target.value); this.props.selectCostCenterByLocation(e.target.value) }} />
            </div>
            <div className="col s12 m6 l4">
              <TextInput id={'gangNo'} label={'Team No.'} />
            </div>
          </div>
          <div className="row">
          <div className="col s12 m6 l3">
              <TimePicker2 id={'gangStartTime'} label={'Start Time'} />
            </div>
            <div className="col s12 m6 l3">
              <TimePicker2 id={'gangEndTime'} label={'End Time'} />
            </div>
            <div className="col s12 m6 l3">
              <Select id={'gangShift'} opts={SHIFTS} label={'Shift'} />
            </div>
            <div className="col s12 m6 l3">
              <NumberInput id={'round'} label={'Round'} min={1} max={6} step={1} defaultValue={1} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m2 l2">
              <SelectCostCenter id={'gangCostCenterCode'} opts={this.props.costCenters} label={'Cost Center'} onChange={(e) => this.props.fetchSubAccounts(e.target.value)} />
            </div>
            <div className="col s12 m2 l2">
              <SelectSubAccount id={'gangSubAccount'} opts={this.props.subAccounts} label={'Sub Account'} onChange={(e) => setCCSubInWorkPerformed('gangWorkPerformed', 'gangCostCenterCode', e.target.id)} />
            </div>
            <div className="col s2 m2 l2 xl2">
              <SelectField id={`gangField`} label={'Field'} opts={this.props.fields} />
            </div>
            <div className="col s12 m3 l2">
              <TextInput id={'gangWorkPerformed'} label={'Work Performed'} />
            </div>
            <div className="col s12 m2 l2">
              <NumberInput id={'gangHours'} min={"0"} max={"16"} label={'Hours'} step={"0.1"} />
            </div>
            <div className="col s12 m2 l2 trainer">
              <button onClick={() => this.packageWorkPerformed(this.props.addWorkToGangTimesheet)} className="btn waves-effect waves-light">Add Work</button>
            </div>
            <div className="col s12 m2 l2 trainer">
              <button id={'gang-work-edit-btn'} onClick={() => this.packageWorkPerformed(this.props.editGangWorkRecord)} className="btn waves-effect waves-light blue">Edit Work</button>
            </div>
          </div>
          {
            this.props.gangWorkPerformed.length > 0 ?
              <div className="row">
                <GangWorkTable work={this.props.gangWorkPerformed} editWork={this.props.editGangWorkInTimesheet} removeWork={this.props.deleteWorkInGangTimesheet} />
              </div>
            : ''
          }

          <hr />
          <div id="emp-list-gang">
            {
              this.props.addedGangEmployees.map((e) => (
                <div key={e.id}>
                  <div className="row">
                    <div className="col s2 m2 l2 xl2">
                      <div id="emp-name-gang" className="card">
                        <span className="flow-text empname-gangts">{ e.firstName } { e.lastName }</span>
                        <input type="hidden" id={`${e.eid}-eid`} value={e.eid} />
                        <input type="hidden" id={`${e.eid}-positionType`} value={e.positionType} />
                        <input type="hidden" id={`${e.eid}-subgrade`} value={e.subgrade} />
                      </div>
                    </div>
                    <div className="col s2 m2 l2 xl1">
                      <NumberInput id={`${e.eid}-hours`} min={"0"} max={"8"} step={'0.1'} label={'Hours'} />
                    </div>
                    <div className="col s2 m2 l2 xl1">
                      <NumberInput id={`${e.eid}-trees`} min={"0"} max={"75"} step={'1'} label={'Trees'} />
                    </div>
                    <div className="col s2 m2 l2 xl1">
                      <NumberInput id={`${e.eid}-bags`} min={"0"} max={"25"} step={'0.25'} label={'Bags'} />
                    </div>
                    <div className="col s2 m2 l2 xl2">
                      <SelectField id={`${e.eid}-field`} label={'Field'} opts={this.props.fields}
                        onChange={(event) => this.props.fetchBlocksByField(event.target.value,`${e.eid}-field`)} />
                    </div>
                    <div className="col s2 m2 l2 xl2">
                      <SelectBlock id={`${e.eid}-block`} label={'Block'} opts={this.props.blocks} />
                    </div>
                    <div className="co2 s2 m2 l2 xl1">
                      <button className={`btn-floating waves-effect waves-light red`} onClick={() => this.props.removeEmployeeFromGang(e.eid)}>
                        <i className="material-icons">clear</i>
                      </button>
                    </div>
                    <div className="co2 s2 m2 l2 xl1">
                      <button className={`btn-floating waves-effect waves-light green`} onClick={() => this.props.addNewGangInfoRow(e.eid)}>
                        <i className="material-icons">add</i>
                      </button>
                    </div>
                  </div>
                  {
                    this.props.addedGangInfoRow.length > 0 ?
                      this.props.addedGangInfoRow.map((field) => {
                        if (field.eid === e.eid) {
                          if (field.count.length > 0) {
                            return field.count.map((f,i) => (
                              <div key={f.eid}>
                                <div className="row">
                                  <div className="col s2 m2 l2 xl2">
                                    <b>Next Input {i+2}: </b><br /><span className="flow-text empname-gangts">{e.firstName} {e.lastName}</span>
                                    <input type="hidden" id={`${field.eid}-${i}-eid`} value={field.eid} />
                                  </div>
                                  <div className="col s2 m2 l1 xl1">
                                    <NumberInput id={`${field.eid}-${i}-hours`} min={"0"} max={"8"} step={"0.05"} label={'Hours'} />
                                  </div>
                                  <div className="col s2 m2 l1 xl1">
                                    <NumberInput id={`${field.eid}-${i}-trees`} min={"0"} max={"75"} step={"0.05"} label={'Trees'} />
                                  </div>
                                  <div className="col s2 m2 l1 xl1">
                                    <NumberInput id={`${field.eid}-${i}-bags`} min={"0"} max={"25"} step={"0.05"} label={'Bags'} />
                                  </div>
                                  <div className="col s2 m2 l2 xl2">
                                    <SelectField id={`${field.eid}-${i}-field`} label={'Field'} opts={this.props.fields}
                                      onChange={(event) => this.props.fetchBlocksByField(event.target.value,`${field.eid}-${i}-field`)} />
                                  </div>
                                  <div className="col s2 m2 l2 xl2">
                                    <SelectBlock id={`${field.eid}-${i}-block`} label={'Block'} opts={this.props.blocks} />
                                  </div>
                                </div>
                              </div>
                            )) }
                          }
                        return '';
                      }) : ''
                  }
                  <div className="row">
                    <div className="col s12 m12 l3">
                      <Select
                        id={`${e.eid}-paycode`}
                        opts={this.props.paycodes.map((p) => { return { val: p.code, label: p.label } })}
                        label={'Special Pay Code'}
                      />
                    </div>
                    <div className="col s12 m12 l3">
                      <TextInput id={`${e.eid}-paycodeDescription`} label={'Description'} />
                    </div>
                    <div className="col s12 m12 l3">
                      <NumberInput id={`${e.eid}-paycodeHours`} min={"0"} max={"12"} step={'0.1'} label={'Hours'} />
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
          <div className="row">
            <TimesheetGangModal id={'gang-ts-modal'} timesheet={this.props.gangTS}
              submitGangTimesheet={this.props.submitGangTimesheet}
              payPeriodStartDate={this.props.payPeriodStartDate} payPeriodEndDate={this.props.payPeriodEndDate}
              prevPPStartDate={this.props.prevPPStartDate} prevPPEndDate={this.props.prevPPEndDate}
              user={this.props.user}
            />
            <div className="col s12">
              <button data-target="gang-ts-modal" onClick={() => this.prepareGangForm()}
                className="btn waves-light waves-effect">
                Prepare
              </button>
            </div>
          </div>
        </form>
      </div>
    )
  }
};



export default GangTimesheetForm;




/* END */



// WEBPACK FOOTER //
// ./src/components/timesheets/create/timesheet_gang_form.js